export default __webpack_public_path__ + "static/media/coloredInstagramIcon.88a006da.png";